import * as React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Login from "../components/Login";
import Signup from "../components/Signup";

const SignInOutContainer = ({ handleClose, handleLogin }) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
  const paperStyle = { width: 360, margin: "0 auto" };
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  return (
    <Paper elevation={20} style={paperStyle}>
      <Tabs value={value} onChange={handleChange} centered>
        <Tab label="Logg Inn" />
        <Tab label="Registrer" />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Login handleChange={handleChange} handleLogin={handleLogin} handleClose={handleClose} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Signup />
      </TabPanel>
    </Paper>
  );
};




export default SignInOutContainer;